import React from 'react';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import { Props } from 'lib/images/svg-image/svg-image';
import defaultStyles from './author-svg-icon.scss';

export default (props: Omit<Props, 'styles'>) => <SVGIcon style={{ image: defaultStyles.icon }} {...props} />;
